function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AppNavigation from '@nextcloud/vue/dist/Components/AppNavigation';
import AppNavigationItem from '@nextcloud/vue/dist/Components/AppNavigationItem';
import ActionButton from '@nextcloud/vue/dist/Components/ActionButton';
import Actions from '@nextcloud/vue/dist/Components/Actions';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'PersonsNavigation',
  components: {
    AppNavigation: AppNavigation,
    AppNavigationItem: AppNavigationItem,
    ActionButton: ActionButton,
    Actions: Actions
  },
  data: function data() {
    return {
      menuOpenPersonId: 0,
      showNewPersonForm: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState(['activePersonId', 'activeModule', 'showSidebar', 'persons'])), mapGetters(['person', 'personsLength'])), {}, {
    getPersons: function getPersons() {
      return this.persons && this.persons.length > 0 // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      ? this.persons.sort(function (a, b) {
        return a.id - b.id;
      }) : null;
    }
  }),
  methods: {
    createPerson: function createPerson(e) {
      var name = e.currentTarget.childNodes[0].value;
      this.$store.dispatch('addPerson', name);
      this.$store.commit('showSidebar', true);
      this.showNewPersonForm = false;
      e.currentTarget.childNodes[0].value = '';
    },
    personUpdateName: function personUpdateName(v) {
      this.$store.dispatch('setValue', {
        id: this.persons[this.menuOpenPersonId].id,
        key: 'name',
        value: v
      });
    },
    closeNewPersonForm: function closeNewPersonForm() {
      this.$refs.newPersonName.value = '';
      this.showNewPersonForm = false;
    }
  }
};